module.exports = __webpack_public_path__ + "media/images/main/karacsony-9bee078ce498b44702456e818cce15f8.jpg";